import { render, staticRenderFns } from "./PDFOMP.vue?vue&type=template&id=b25cdc02&"
import script from "./PDFOMP.vue?vue&type=script&lang=js&"
export * from "./PDFOMP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports